export default {
  locale: "es",
  name: "CancellationPoliciesconfiguration",
  translation: { displayName: "Translations" },
  fields: {
    /** Here are te entities used in the lists, Order is important */
    /** fieldName: this is used like the id container of the properties */
    /** displayName: this is the title rendered */
    list: [
      {
        fieldName: "startDate",
        displayName: "Fecha inicio",
      },
      {
        fieldName: "endDate",
        displayName: "Fecha fin",
      },
      {
        fieldName: "weekDays",
        displayName: "Días de la semana",
      },
      {
        fieldName: "hourRange",
        displayName: "Rango de horas",
      },
      {
        fieldName: "timeZone",
        displayName: "Huso horario",
      },
    ],
    /** Here is the entity used in the forms, Order is important */
    /** all the properties can be found in app/components/CRUD/Common, at the corresponding js file */
    /** fieldName: is like the id in html, it must be unique among the attributes */
    /** widget: is used to render the kind of interaction the user will have, a complete list can be found in component/CRUD/Common */
    /** displayName: The text that introduces the widget */
    /** defaultValue: The default value of the widget */
    /** optionDisplay: An object that containes objects with the option at the select */
    form: [
      {
        fieldName: "restrictions",
        widget: "openBooking",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Introducir fecha",
        isRange: true,
        startField: "startDate",
        endField: "endDate",
        className: "tickerInput",
      },
    ],
  },
};
